<div class="verify-page">
  <div class="verify-shell">
    <!-- Left Visual Panel -->
    <div class="verify-visual">
      <div class="visual-content">
        <!-- <div class="visual-brand">
          <img src="assets/images/ab_assist_new.svg" alt="Absence Assistance" />
        </div> -->

        <div class="visual-image">
          <img
            src="assets/images/absences_lms_login_banner.png"
            alt="Account verification"
          />
        </div>

        <div class="visual-footer">
          <span>
            <i class="pi pi-envelope"></i>
            Email verification
          </span>

          <span>
            <i class="pi pi-lock"></i>
            Secure access
          </span>
        </div>
      </div>
    </div>

    <!-- Right Verification Panel -->
    <div class="verify-panel">
      <div class="verify-content">
        <!-- Mobile Logo -->
        <div class="mobile-brand">
          <img src="assets/images/ab_assist_new.svg" alt="Absence Assistance" />
        </div>

        <!-- Header -->
        <div class="verify-header">
          <!-- <div class="verify-icon">
          <i class="pi pi-envelope"></i>
        </div> -->

          <!-- <span class="verify-eyebrow"> Email verification </span> -->

          <h2>Verify your account</h2>

          <p>
            Enter the 6-digit verification code that was sent to your registered
            email address.
          </p>
        </div>

        <!-- Error -->
        @if (validErrMsg) {
        <div class="verify-alert" role="alert">
          <div class="alert-icon">
            <i class="pi pi-exclamation-circle"></i>
          </div>
          <div class="alert-message">
            {{ validErrMsg }}
          </div>
          <button
            type="button"
            class="alert-close"
            (click)="removeErrMsg()"
            aria-label="Close notification"
          >
            <i class="pi pi-times"></i>
          </button>
        </div>
        }

        <!-- OTP Form -->
        <form [formGroup]="verifyForm" class="verify-form">
          <div class="form-field">
            <label for="verify_otp"> Verification code </label>

            <input
              id="verify_otp"
              class="otp-input"
              type="text"
              inputmode="numeric"
              pattern="[0-9]*"
              placeholder="••••••"
              formControlName="verify_otp"
              minlength="6"
              maxlength="6"
              autocomplete="one-time-code"
              (keypress)="isNumberOnly($event)"
            />

            <form-validation [control]="verifyForm.controls.verify_otp">
            </form-validation>

            <div class="otp-hint">
              <i class="pi pi-info-circle"></i>
              Enter the 6-digit code from your email.
            </div>
          </div>

          <!-- Verify -->

          @if(!showVerificationPin){
            <button
            type="button"
            class="verify-button"
            [disabled]="verifyForm.get('verify_otp')?.value?.length !== 6"
            (click)="verifyAcc(verifyForm.value)"
          >
            <span>Verify Account</span>

            <i class="pi pi-arrow-right"></i>
          </button>
          }

          @if (showVerificationPin) {
          <button type="button" class="verify-button loading" disabled>
            <span class="spinner-border"></span>
            <span>Verification in progress...</span>
          </button>
          }
        </form>

        <!-- Login -->
        <div class="login-section">
          <span>Already registered?</span>

          <a class="login-link" (click)="redirectToSignIn()"> Sign in </a>
        </div>

        <!-- Security -->
        <div class="verify-security">
          <i class="pi pi-lock"></i>

          <span> Your verification code is securely processed. </span>
        </div>
      </div>
    </div>
  </div>
</div>
